module.exports = __webpack_public_path__ + "img/tabla-header-1.aaf5d7ba.svg";